import { useEffect, useState, type ReactNode } from 'react';
import { ConfigProvider } from 'antd-mobile';
import enUS from 'antd-mobile/es/locales/en-US';
import zhCN from 'antd-mobile/es/locales/zh-CN';
import { useTranslation } from 'react-i18next';

export function MobileLocaleProvider({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  const [locale, setLocale] = useState(i18n.language === 'zh-CN' ? zhCN : enUS);

  useEffect(() => {
    const sync = (lang: string) => {
      setLocale(lang === 'zh-CN' ? zhCN : enUS);
    };
    sync(i18n.language);
    i18n.on('languageChanged', sync);
    return () => {
      i18n.off('languageChanged', sync);
    };
  }, [i18n]);

  return <ConfigProvider locale={locale}>{children}</ConfigProvider>;
}

export default MobileLocaleProvider;
